export default "__VITE_ASSET__745a4e37__"